import client from '../../client';

const endpoint = '/v2/global/categories';


/**
 * Get the categories with the given params from the backend.
 * For more information please read the backend docs.
 */
export function get(params) {
  return client.get(endpoint, { params }).then(({ data }) => data)
}


export default {
  get,
}
